import React from 'react'
import { useMemo } from 'sb-hooks'

// Brands can't send good svg logos, then need to use small size png.
import dgImage from '!!src-loader!./images/dg.png'
import nestImage from '!!src-loader!./images/nest.png'
import acquaImage from '!!src-loader!./images/acqua.png'
import gucciImage from '!!src-loader!./images/gucci.png'
import pradaImage from '!!src-loader!./images/prada.png'
import versaceImage from '!!src-loader!./images/versace.png'
import bulgariImage from '!!src-loader!./images/bulgari.png'
import cartierImage from '!!src-loader!./images/cartier.png'
import tomFordImage from '!!src-loader!./images/tom-ford.png'

// SVG
import elleImage from './images/elle.svg'
import bazaarImage from './images/bazaar.svg'
import bustleImage from './images/bustle.svg'
import forbesImage from './images/forbes.svg'
import inStyleImage from './images/inStyle.svg'
import glamourImage from './images/glamour.svg'


const brands = {
  // png
  dg: dgImage,
  nest: nestImage,
  acqua: acquaImage,
  gucci: gucciImage,
  prada: pradaImage,
  versace: versaceImage,
  bulgari: bulgariImage,
  cartier: cartierImage,
  tomFord: tomFordImage,

  // svg
  elle: elleImage,
  bazaar: bazaarImage,
  bustle: bustleImage,
  forbes: forbesImage,
  inStyle: inStyleImage,
  glamour: glamourImage,
}

export type BrandLogoTypes = {
  className?: string
  name: keyof typeof brands
}

const BrandLogo: React.FunctionComponent<BrandLogoTypes> = ({ className, name }) => {
  const image = brands[name]

  if (!image) {
    console.error(`There is no brand with name "${name}"`)
  }

  const imageProps = useMemo(() => {
    if (image && typeof image === 'object') {
      return { ...image }
    }

    return { src: image }
  }, [ image ])

  return (
    <img
      className={className}
      alt={name}
      {...imageProps}
    />
  )
}


export default React.memo(BrandLogo)
